<nz-spin [nzSize]="'large'" [nzTip]="text"><div style="width: 150px; height: 100px"></div></nz-spin>
